import React, { useContext, useEffect, useState } from 'react';
import {
  SearchFacetsResponse,
  SearchFacetsResponseBuckets,
  SearchStateExtendsType,
  SearchStateFilterObj,
} from '../../organisms/SearchResults/store/store.type';
import { SearchFacetsList, SearchFacetsListCodes } from '../../organisms/SearchResults/index.constant';
import { SearchFilterContext } from '../../organisms/SearchResults/index.context';
import { StyledCheckboxItemDiv, StyledCheckboxItemsContainer } from '../../organisms/SearchResults/index.styles';
import { StyledActivitiesFilterDiv } from './index.styles';
import { Checkbox } from '@marriott/mi-ui-library-shop';
import { useWindowSize } from '../../hooks';

import { formatNumberByLocale } from '../../utils';
import { useSessionUpdateContext } from '../../context/SessionUpdateContext';
import { usePageContext } from '../../context/PageContext/index';
import { BREAKPOINT_DESKTOP_1023, BREAKPOINT_TABLET } from '../../organisms/SearchResults/lib/application.constants';

declare module 'react' {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  interface HTMLAttributes<T> {
    custom_click_track_value?: string;
  }
}

export const ActivitiesFilterComponent: React.FC<{
  onItemSelect: (arg: SearchFacetsList, arg2: SearchStateFilterObj) => void;
  clearFilterState: SearchStateExtendsType | undefined | null;
  activities?: SearchFacetsResponse;
  itemList?: SearchFacetsResponse;
}> = ({ onItemSelect, clearFilterState, activities, itemList }) => {
  const { searchQueryState } = useContext(SearchFilterContext);
  const { interactionsSelected, setInteractionsSelected } = useSessionUpdateContext();
  const clickTrackingLoc = 'Phoenix Search Results';
  const { currentLocale } = usePageContext();

  const [currSelectedItem, setCurrSelectedItem] = useState<SearchStateFilterObj | undefined>(
    searchQueryState[SearchFacetsList.activities]
  );
  const { width } = useWindowSize();

  const getCurrenActivities = (): SearchFacetsResponse =>
    activities ??
    (itemList
      ? itemList
      : // eslint-disable-next-line @typescript-eslint/no-explicit-any
        searchQueryState?.filter?.filter((key: any) => key?.type?.code === SearchFacetsListCodes?.activities)[0]);

  const [allActivities, setAllActivites] = useState<SearchFacetsResponse | undefined>(getCurrenActivities());

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const onSelectFilter = (event: any, data: SearchFacetsResponseBuckets): void => {
    if (event.key === 'Enter' || event.type === 'click' || event.type === 'change' || event.keyCode === 13) {
      let obj: SearchStateFilterObj | undefined = { ...currSelectedItem };
      if (obj !== undefined) {
        if (data.code in obj) {
          delete obj[data.code];
        } else {
          obj[data.code] = data.code;
        }
      } else {
        obj = {};
        obj[data.code] = data.code;
      }
      setCurrSelectedItem(obj);
      if (onItemSelect) {
        onItemSelect(SearchFacetsList.activities, obj);
      }
    }
    setInteractionsSelected({ ...interactionsSelected, activities: true });
  };

  useEffect(() => {
    setAllActivites(getCurrenActivities());
  }, [itemList]);

  useEffect(() => {
    if (clearFilterState === undefined || clearFilterState === null) {
      setCurrSelectedItem(undefined);
    }
  }, [clearFilterState]);

  return allActivities?.type.count ? (
    <StyledActivitiesFilterDiv className="t-font-alt-s hotel-types-filters-container">
      <fieldset>
        <div className="t-font-alt-s filter-heading-container">
          <legend>
            <h4
              className={
                (width && width > BREAKPOINT_DESKTOP_1023
                  ? `t-subtitle-l`
                  : width && width > BREAKPOINT_TABLET
                  ? `t-subtitle-l`
                  : `t-subtitle-m`) + ' filter-heading'
              }
            >
              {allActivities?.type?.label}
            </h4>
          </legend>
        </div>
        <StyledCheckboxItemsContainer className={`hotel-types-container `}>
          {allActivities?.buckets?.map((hotelType: SearchFacetsResponseBuckets, idx: number) => (
            <StyledCheckboxItemDiv className="m-checkbox-selection-item hotel-type-description" key={idx}>
              <Checkbox
                variation="simple"
                className=""
                checkboxId={`${hotelType?.code}-checkbox`}
                checkboxName="hotel_type_filter_checkbox"
                onChange={(e): void => onSelectFilter(e, hotelType)}
                onKeyDown={(e): void => onSelectFilter(e, hotelType)}
                checked={currSelectedItem ? hotelType.code in currSelectedItem === true : false}
                inputClassName="checkbox-input custom_click_track"
                setTabIndex={-1}
                children={
                  <>
                    <span className="t-font-s hotel-type-name">{hotelType?.label}</span>
                    {hotelType?.count && (
                      <span className="t-font-s pl-1">({formatNumberByLocale(hotelType?.count, currentLocale)})</span>
                    )}
                  </>
                }
                {...{
                  custom_click_track_value: `${clickTrackingLoc}| Activities options:${hotelType?.label} |internal`,
                }}
              />
            </StyledCheckboxItemDiv>
          ))}
        </StyledCheckboxItemsContainer>
      </fieldset>
      <hr aria-hidden className="filter-separator" />
    </StyledActivitiesFilterDiv>
  ) : null;
};
